import ShopaholicCartRemove from '@lovata/shopaholic-cart/shopaholic-cart-remove';
import LazyLoad from '@src/js/lazy-load';

export default new class CartHeader {
    constructor() {
        this.cartHederWrapper = 'header-cart';
        this.productIDAttribute = 'data-product-id';
        this.positionIDAttribute = 'data-position-id';
        this.init();
    }

    init() {
        this.addListenerToRemoveCartButton();
    }

    addListenerToRemoveCartButton() {
        const obShopoholicCartRemove = new ShopaholicCartRemove();
        obShopoholicCartRemove.setAjaxRequestCallback((obRequestData, obButton) => {
            const productWrapper = obButton.closest('._shopoholic-product-wrapper');
            if (productWrapper) {
                obRequestData.data.product_id = productWrapper.getAttribute(this.productIDAttribute);
                obRequestData.data.position_id = productWrapper.getAttribute(this.positionIDAttribute);
            }
            obRequestData.update = {
                'header/header-cart': `.${this.cartHederWrapper}`,
            };
            obRequestData.complete = () => {
                this.updateAjaxComplete();
            }
            return obRequestData;
        }).init();
    }

    updateAjaxComplete() {
        LazyLoad.update();
        $(`body, html`).animate({ scrollTop: this.topPosition }, 350);
    }

}();


$(document).ready(function () {

    $('.catalog-aside__collapse-link').click(function(){
        $(this).toggleClass('show')
        $(this).next('.catalog-aside__collapse-list').slideToggle()
    });

});

